import { useEffect, useState } from "react";
let isSSR = true;
/**
 * Use this function to help with SSR edge-cases.
 *
 * On the server, this hook will always return `true`.
 *
 * On the client, this hook will return `true` once, after hydration, and then switch to `false`.
 */
export function useIsSSR() {
    const [value, setValue] = useState(isSSR);
    useEffect(() => {
        if (!isSSR)
            return;
        setValue(false);
        const timer = setTimeout(() => {
            isSSR = false;
        }, 5000);
        return () => clearTimeout(timer);
    }, []);
    return value;
}
